import { all, call } from 'redux-saga/effects';
import formActionSaga from 'redux-form-saga';

import { watchAuth } from 'auth/sagas';
import { watchHandleLogin } from 'auth/LoginForm/sagas';
import { watchPurchases } from 'billing/purchases/sagas';
import { watchPaymentMethods } from 'billing/paymentMethods/sagas';
import { watchPayPurchase } from 'billing/purchases/PayPurchase/sagas';
import { watchCycles } from 'billing/cycles/sagas';
import { watchQuickCycles } from 'billing/cycles/quick/sagas';
import { watchRenewal } from 'billing/renewal/sagas';
import { watchSprintSubscriptions } from 'subscriptions/sprint/sagas';
import { watchBypassedSubscriptions } from 'subscriptions/bypassed/sagas';
import { watchQuickSubscriptions } from 'subscriptions/quick/sagas';
import { watchUsage } from 'subscriptions/usage/sprint/sagas';
import { watchUsage as watchQuickUsage } from 'subscriptions/usage/quick/sagas';
import { watchNotifications } from 'notifications/sagas';
import { watchAccount } from 'account/sagas';
import { watchSprintPlans } from 'subscriptions/plans/sprint/sagas';
import { watchBypassedPlans } from 'subscriptions/plans/bypassed/sagas';
import { watchQuickPlans } from 'subscriptions/plans/quick/sagas';
import { watchDevices } from 'devices/sagas';
import { watchInsurancePlans } from 'insurance/insurancePlans/sagas';
import { watchInsuranceContracts } from 'insurance/insuranceContracts/sagas';
import { watchInsuredDevices } from 'insurance/insuredDevices/sagas';
import { watchInsurance } from 'insurance/sagas';
import { watchOrderSim } from 'ordersim/sagas';
import { watchProducts } from 'ordersim/products/sagas';
import { watchInsuranceLink } from 'insurance/Link/sagas';
import { watchPaymentArrangement } from 'paymentArrangement/sagas';

export default function* mainSaga() {
  yield all([
    call(watchAuth),
    call(watchHandleLogin),
    call(formActionSaga),
    call(watchPurchases),
    call(watchPaymentMethods),
    call(watchPayPurchase),
    call(watchCycles),
    call(watchQuickCycles),
    call(watchRenewal),
    call(watchSprintSubscriptions),
    call(watchBypassedSubscriptions),
    call(watchQuickSubscriptions),
    call(watchUsage),
    call(watchQuickUsage),
    call(watchNotifications),
    call(watchAccount),
    call(watchSprintPlans),
    call(watchBypassedPlans),
    call(watchQuickPlans),
    call(watchDevices),
    call(watchInsurancePlans),
    call(watchInsuranceContracts),
    call(watchInsuredDevices),
    call(watchInsurance),
    call(watchOrderSim),
    call(watchProducts),
    call(watchInsuranceLink),
    call(watchPaymentArrangement),
  ]);
}
